<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/logo/its_logo_horizontal.png" alt="ITS Logo" class="mx-auto" width="250">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container" v-if="!is_enabled_2fa">

                <div class="vx-card__title mb-4 text-center">
                  <h4 class="mb-4">Supplier Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <div>
                  <vs-input
                      name="email"
                      icon-no-border
                      icon-pack="feather"
                      label-placeholder="Email"
                      v-model="email"
                      class="w-full"/>

                  <vs-input
                      type="password"
                      name="password"
                      icon-no-border
                      icon-pack="feather"
                      label-placeholder="Password"
                      v-model="password"
                      @keyup.enter="onClickLogin"
                      class="w-full mt-6" />


                  <div class="flex flex-wrap justify-between my-5">
                      <router-link to="/pages/forgot-password">Forgot Password?</router-link>
                  </div>
                  <vs-button  type=""></vs-button>
                  <vs-button id="login" @click="onClickLogin" class="float-right">Login</vs-button>
                </div>
              </div>

              <div class="p-8 login-tabs-container" v-if="is_enabled_2fa">
                <div class="vx-card__title mb-4 text-center">
                  <h4 class="mb-4">Enter your 2-step verification code</h4>
                  <p>A 6-digit code is generated by your phone.</p>
                </div>
                <img src="@/assets/images/pages/login/google-auth.png" alt="ITS Logo" class="mx-auto" width="130"/>
                <div  id="verify-page" class="flex flex-wrap justify-center mb-12 mt-8">
                  <v-otp-input
                      ref="otpInput"
                      input-classes="otp-input"
                      separator="-"
                      :num-inputs="6"
                      :should-auto-focus="true"
                      :is-input-num="true"
                      @on-complete="handleOnComplete"
                    />
                </div>
                <div class="flex flex-wrap justify-between my-5">
                    <vx-tooltip
                      title="Invalid token?"
                      color="dark"
                      position="bottom"
                      :text="invalid_token_para">
                      <a class="cursor-pointer">2FA code not working? </a>
                    </vx-tooltip>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import ErrorMessages from '@/mixins/ErrorMessages'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import OtpInput from "@bachdgvn/vue-otp-input";
  import { mapGetters, mapActions } from 'vuex'
  import axios from '@/axios'
  import profile from '@/apis/profile'
export default{
  data () {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      login_data: {},
      invalid_token_para: 'If your 2FA tokens are shown as invalid try to time-sync your mobile device. Your time must show correct local time, date and time zone for the authenticator to work properly. Android and Windows phones have an option to correct for time errors inside the Authenticator app properties if you do not wish to sync your clock. iOS devices must be set to use Internet time to make sure the clock is synced properly.',
      two_fa_code: ''
    }
  },
  mounted() {
    this.$vs.loading.close()
  },
  computed: mapGetters(["is_enabled_2fa"]),
  mixins: [ErrorMessages, SuccessMessage],
  components: {
    "v-otp-input": OtpInput
  },
  methods: {
    ...mapActions(['login', 'loginAfter2FA']),
    async handleOnComplete(value) {
      try {
        this.two_fa_code = value
        await this.onClickVerify2FA()
      } catch (error) {
        console.log(error);
        this.convertAndNotifyError(error)
      }
    },
    async onClickVerify2FA() {
      await this.$vs.loading({
        container: '#verify-page',
        scale: 0.45
      })
      try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.login_data.token}`
        const { data } = (await profile.verify2FA({ secret: this.two_fa_code }, this.login_data.user.id)).data
        this.showSuccessMessage(data.message)
        await this.loginAfter2FA(this.login_data)
        this.$router.push('/')
      } catch (e) {
        console.log(e);
        this.convertAndNotifyError(e)
        this.$refs.otpInput.clearInput();
      }
      this.$vs.loading.close('#verify-page > .con-vs-loading')
    },
    async onClickLogin() {
      try {
        await this.$vs.loading({
          container: '#login',
          scale: 0.45
        })
        this.login_data = await this.login({
          email: this.email,
          password: this.password,
        })
        if(!this.is_enabled_2fa) {
          this.$router.push('/')
        }
        console.log(this.login_data);
        this.$vs.loading.close('#login > .con-vs-loading')
      } catch (error) {
        console.log(error);
        this.convertAndNotifyError(error)
        this.$vs.loading.close('#login > .con-vs-loading')
        this.password = ''
      }
    }
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
.otp-input {
  width: 45px;
  height: 45px;
  padding: 2px;
  margin: 0 5px;
  font-size: 25px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
